import {CursorType} from '@/enums/diagrams';
import {HarmonicCursor} from './harmonicCursor';
import {CursorLabelModel} from './labelModels/cursorLabelModel';

/*
	Класс cубгармонического курсора
*/
export class SubHarmonicCursor extends HarmonicCursor {
  // Тип курсора
  type: CursorType = CursorType.SubHarmonicCursor;

  // Количество линий гармоник (не считая основную линию курсора)
  linesCount = 4;
  subLinesFreqShift = 0;

  constructor(
    labelModel: CursorLabelModel | null = null,
    applyCallback: Function | null = null,
    color = '#03C2FCFF',
    linesCount = 4,
  ) {
    super(
      labelModel,
      applyCallback,
      color,
      linesCount,
      (value: number, index: number) => value / (index + 2),
      (value: number, index: number) => value * (index + 2),
    );
  }
}
